'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayName = undefined;

var _getDisplayName2 = require('./get-display-name');

var _getDisplayName3 = _interopRequireDefault(_getDisplayName2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getDisplayName = _getDisplayName3.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-sizes/lib/utils/index.js
// module id = 837
// module chunks = 0